export default {
  fieldStyles: {
    // empty
  },
};
